import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fine',
  templateUrl: './fine.component.html',
  styleUrls: ['./fine.component.scss']
})
export class FineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
